<template lang="html">
  <div>
    <d-button-group class="buttons">
      <d-checkbox toggle @change="toggleSpam" :checked="(lead.status == 'spam')" class="custom-toggle-sm">Spam</d-checkbox>
    </d-button-group>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import Events from '_utils/events';
import { _DELETE_LEAD_ } from '_modules/lead/components/LeadModel';

export default {
  name: 'lead-buttons',
  props: {
    lead: {
      type: Object,
      default: null,
    },
  },
  components: {},
  computed: {},
  methods: {
    ...mapActions([
      'setToggle',
      'activeAlert',
    ]),
    confirmDeleteRow() {
      this.setToggle({ type: 'confirm_modal', bool: true });
      Events.$emit(_DELETE_LEAD_, this.lead);
    },
    toggleSpam() {
      this.$emit('toggleSpam', this.lead);
    },
  },
  mounted() {},
};
</script>
